module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai341-c5583d5142cf27350cd613329dff2269.jpg";